import { Attachment } from './attachments.model';
import { FlowchartActionDto } from './FlowchartActionDto';
import { FlowchartDecisionNodeDto } from './FlowchartDecisionNodeDto';
import { FlowchartElementType } from './FlowchartElementType';
import { FlowchartLinkDto } from './FlowchartLinkDto';
import { FlowchartNodeStyleDto } from './FlowchartNodeStyleDto';
import { FlowchartSelectionBehaviorDto } from './FlowchartSelectionBehaviorDto';
import { FlowchartStartNodeDto } from './FlowchartStartNodeDto';
import { FlowchartTextBlockDto } from './FlowchartTextBlockDto';
import { GuidelineLinkDto } from './GuidelineLinkDto';
import { Reference } from './reference.model';
import { ResourceTag } from './widgets/resource-tag.model';

export type FlowchartNodeType = FlowchartStartNodeDto &
  FlowchartActionDto &
  FlowchartDecisionNodeDto &
  FlowchartSelectionBehaviorDto &
  FlowchartLinkDto &
  FlowchartTextBlockDto &
  FlowchartNodeDto;

export class FlowchartNodeDto {
  id?: string | null;
  uniqueId?: string;
  guidelineChapterId?: string | null;
  elementType?: FlowchartElementType;
  attachments?: Attachment[];
  positionX?: number;
  positionY?: number;
  width?: number;
  height?: number;
  customStyling?: FlowchartNodeStyleDto;
  parentId?: string | null;
  children?: FlowchartNodeDto[];
  outgoingLinks?: FlowchartLinkDto[];
  showDescription?: boolean;
  references?: Reference[];
  links?: GuidelineLinkDto[];
  descriptionReferences?: Reference[];
  descriptionBelowReferences?: Reference[];
  resourceTags?: ResourceTag[];
  colorPresetId?: string | null;
}
